import React from 'react'
import Cookies from 'universal-cookie';

import './Main.css';

import Menu from './Menu';
import Footer from './Footer';
import ListItem from './ListItem';
import Separator from './Separator';
import Message from './Message';

import I18N from '../utils/I18N';

function Main() {
  const cookies = new Cookies();
  const locale = cookies.get('locale') || 'pt_BR';

  function openOZmap() {
    const proto = window.location.protocol;
    const host = window.location.hostname;

    const url =
        proto === "https:"
            ? `https://${host}:9994`
            : `http://${host}:9090`;

    window.open(url, "_blank")?.focus();
  }

  function openOZloc() {
    const proto = window.location.protocol;
    const host = window.location.hostname;

    const url =
        proto === "https:"
            ? `https://${host}:9443`
            : `http://${host}:8081`;

    window.open(url, "_blank")?.focus();
  }

  function openDashboard() {
    const proto = window.location.protocol;
    const host = window.location.hostname;

    const url =
        proto === "https:"
            ? `https://${host}:9994/?menuItem=tabDashboard`
            : `http://${host}:9090/?menuItem=tabDashboard`;

    window.open(url, "_blank")?.focus();
  }

  function openOZmob() {
    window.open('http://ozmap.com.br/ozmob', '_blank').focus();
  }

  function openOZconverter() {
    window.open('http://ozconverter.ozmap.com.br/', '_blank').focus();
  }

  function openOZsurvey() {
    window.open('http://ozmap.com.br/ozsurvey/', '_blank').focus();
  }

  function openFindMe() {
    window.open('https://ajuda.ozmap.com.br/support/solutions/articles/44001694749-pedindo-a-localizac%C3%A3o-do-cliente-findme', '_blank').focus();
  }

  function openNews() {
    window.open('http://ozmap.com.br/release-notes-geral/', '_blank').focus();
  }

  return (
      <div>
        <Message onClick={openNews} text={I18N.TRANSLATE.NEWS[locale]} />
        <Menu />
        <div className="main-container">
          <div className="sub-container">
            <Separator icon="FiBox" title={I18N.TRANSLATE.MODULES.TITLE[locale]} />
            <div className="items">
              <ListItem onClick={openOZmap} title="OZmap" text={I18N.TRANSLATE.MODULES.OZMAP_DESCRIPTION[locale]} />
              <ListItem onClick={openOZmob} title="OZmob" text={I18N.TRANSLATE.MODULES.OZMOB_DESCRIPTION[locale]} />
              <ListItem onClick={openOZloc} title="OZloc" text={I18N.TRANSLATE.MODULES.OZLOC_DESCRIPTION[locale]} />
              <ListItem onClick={openDashboard} title="Dashboard" text={I18N.TRANSLATE.MODULES.DASHBOARD_DESCRIPTION[locale]} />
            </div>

            <Separator icon="FiTool" title={I18N.TRANSLATE.TOOLS.TITLE[locale]} />
            <div className="items">
              <ListItem onClick={openOZsurvey} title="OZsurvey" text={I18N.TRANSLATE.TOOLS.OZSURVEY_DESCRIPTION[locale]} />
              <ListItem onClick={openFindMe} title="Findme" text={I18N.TRANSLATE.TOOLS.FINDME_DESCRIPTION[locale]} />
              <ListItem onClick={openOZconverter} title="OZconverter" text={I18N.TRANSLATE.TOOLS.OZCONVERTER_DESCRIPTION[locale]} />
            </div>

          </div>
        </div>
        <Footer />
      </div>
  );
}

export default Main;